const compOffHeaders = {
  TransNo: 'Trans No.',
  Date: 'Request Date',
  Day: 'Day',
  Reason: 'Reason',
  'From Time': 'From Time',
  'To Time': 'To Time',
  Days: 'Days',
  Hrs: 'Hrs',
  Approver: 'Approver',
  Status: 'Status',
};

export const LEAVE_STATUS_BADGE_STYLES = {
  Approved: {
    backgroundColor: '#ECFDF3',
    borderColor: '#ABEFC6',
    fontColor: '#067647',
    dotColor: '#17B26A',
  },
  Rejected: {
    backgroundColor: '#FEF3F2',
    borderColor: '#FECDCA',
    fontColor: '#B42318',
    dotColor: '#F04438',
  },
  Pending: {
    backgroundColor: '#EFF8FF',
    borderColor: '#B2DDFF',
    fontColor: '#175CD3',
    dotColor: '#2E90FA',
  },
};

export default compOffHeaders;
